/* Order-by countdown.
   Counts down to real, fixed cut-off dates set in the theme editor (end of day, Zagreb time).
   Every visitor sees the same time; nothing resets per visit. Hides itself after the last date. */
(function () {
  function parse(d) {
    if (!d || !/^\d{4}-\d{2}-\d{2}$/.test(d)) return null;
    var t = Date.parse(d + 'T23:59:59+01:00');
    return isNaN(t) ? null : t;
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function setup(el) {
    if (el.__ttDeadline) return;
    el.__ttDeadline = true;
    var stages = [
      { at: parse(el.getAttribute('data-advent')), label: el.getAttribute('data-label-advent') },
      { at: parse(el.getAttribute('data-christmas')), label: el.getAttribute('data-label-christmas') }
    ].filter(function (s) { return s.at && s.label; });
    var units = (el.getAttribute('data-units') || 'd|h|m|s').split('|');
    var out = el.querySelector('[data-tt-deadline-text]');
    if (!out || !stages.length) return;
    var timer;
    function tick() {
      var now = Date.now();
      var stage = null;
      for (var i = 0; i < stages.length; i++) { if (stages[i].at > now) { stage = stages[i]; break; } }
      if (!stage) { el.hidden = true; clearInterval(timer); return; }
      var left = Math.floor((stage.at - now) / 1000);
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      var parts = [];
      if (d > 0) parts.push(d + units[0]);
      parts.push(pad(h) + units[1], pad(m) + units[2], pad(s) + units[3]);
      var time = '<strong class="tt-deadline__time">' + parts.join(' ') + '</strong>';
      out.innerHTML = esc(stage.label).replace('{time}', time);
      el.classList.toggle('is-final', d < 3);
      el.hidden = false;
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  function init(scope) { (scope || document).querySelectorAll('[data-tt-deadline]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
